export default __webpack_public_path__ + "static/media/step3.f93e5cd9.webp";